import { Duration, Timestamp } from '@bufbuild/protobuf';
import { generateTypes } from '@evmos/eip712';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions/dist/messages/base';
import { MsgBuyExactSpend } from '../ts-client/tx';
import { MsgBuyExactSpend as MsgBuyExactSpendProto } from '../proto/tx_pb';

const MSG_BUY_TYPES = {
  MsgValue: [
    { name: 'buyer', type: 'string' },
    { name: 'plan_id', type: 'string' },
    { name: 'spend', type: 'string' },
    { name: 'min_out_tokens_amount', type: 'string' },
  ],
};

export const createTxMsgBuyExactSpend = (context: TxContext, params: MsgBuyExactSpend): TxPayload => {
  const typedData = createEIP712MsgBuyExactSpend(context, params);
  const cosmosMsg = createCosmosMsgBuyExactSpend(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgBuyExactSpend = (context: TxContext, params: MsgBuyExactSpend): EIP712TypedData => {
  const types = generateTypes(MSG_BUY_TYPES);
  const message = createMsgBuyExactSpend(params);
  return { types, message };
};

const createCosmosMsgBuyExactSpend = (context: TxContext, params: MsgBuyExactSpend): any => {
  const message = new MsgBuyExactSpendProto(params);
  return { message, path: MsgBuyExactSpendProto.typeName };
};

function createMsgBuyExactSpend(params: MsgBuyExactSpend): object | object[] {
  return {
    type: 'iro/BuyExactSpend',
    value: {
      buyer: params.buyer,
      plan_id: params.planId,
      spend: params.spend,
      min_out_tokens_amount: params.minOutTokensAmount,
    },
  };
}

